import { useDistinctCarKeysLazy } from 'data/useDistinctCarKeys';
import { Make, useMakesFindQuery } from 'graphql/generated';
import _ from 'lodash';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cacheActions, cacheSelectors } from 'redux/cache.slice';
import { RootState } from 'redux/root-reducer';
import { searchParamActions, searchParamSelectors } from 'redux/search-param.slice';

// import { useListingsSearch } from '../../data/useListingsSearch';

export const useMakes = () => {
  const dispatch = useDispatch();
  const { data } = useMakesFindQuery();
  const makes: Make[] = data?.makesFind || [];

  // const { updateMakeModels } = useListingsSearch();
  const { loadModels } = useDistinctCarKeysLazy();

  const makesPopularFilter = useSelector((state: RootState) => cacheSelectors.makesPopularFilter(state));
  const makeOptions = useMemo(() => {
    if (data?.makesFind) {
      if (makesPopularFilter) return data.makesFind.filter(x => x.popular).map(x => ({ id: x.name, label: x.name }));
      else return data.makesFind.map(x => ({ id: x.name, label: x.name }));
    } else return [];
  }, [data?.makesFind, makesPopularFilter]);

  const makeModels = useSelector((state: RootState) => searchParamSelectors.makeModels(state));
  const selectedMake = makeModels?.length ? makeModels[0].make : '';
  const selectedMakes = makeModels?.map(x => x.make);

  const setSelectedMakes = (makes: string[], disableSearch?: boolean) => {
    const makesModels = makeModels ? makeModels.filter(x => makes.includes(x.make)) : [];
    for (const make of makes)
      if (!makesModels.map(x => x.make).includes(make)) {
        makesModels.push({ make, models: [] });
        loadModels(make);
      }
    const searchMakesModels = _.orderBy(makesModels, ['make']);
    dispatch(searchParamActions.makeModels(searchMakesModels));
    // if (!disableSearch) updateMakeModels(searchMakesModels);
  };

  // const removeMakeId = (key: string) => {
  //   console.log('remove make', key);
  //   const ary = _.cloneDeep(makeModels);
  //   if (ary?.length) {
  //     ary.splice(
  //       ary.findIndex(x => x.make === key),
  //       1,
  //     );
  //   }
  //   dispatch(searchParamActions.makeModels(_.orderBy(ary)));
  //   // updateMakeModels(makesModels);
  // };
  const setMakesPopularFilter = (value: boolean) => dispatch(cacheActions.makesPopularFilter(value));

  const addMakeKey = (val: string) => {
    const ary = _.cloneDeep(makeModels || []);
    if (!ary.find(x => x.make === val)) ary.push({ make: val, models: [] });
    loadModels(val);
    dispatch(searchParamActions.makeModels(_.orderBy(ary)));
  };

  const removeMakeKey = (val: string) => {
    let ary = makeModels ? _.cloneDeep(makeModels) : [];
    if (ary?.length) ary = ary.filter(x => x.make !== val);
    dispatch(searchParamActions.makeModels(ary));
  };

  return {
    makes,
    makeOptions,
    selectedMake,
    selectedMakes,
    setSelectedMakes,
    // removeMakeId,
    setMakesPopularFilter,
    addMakeKey,
    removeMakeKey,
  };
};
